import React, { memo } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Button,
  Hidden,
  IconButton,
  Typography,
} from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import VideoIcon from "@mui/icons-material/VideoLibrary";
import BlogIcon from "@mui/icons-material/Book";
import PriceIcon from "@mui/icons-material/PriceCheck";
import FAQIcon from "@mui/icons-material/Help";
import NavigationDrawer from "../../../shared/components/NavigationDrawer";
import { borderBottom, Box } from "@mui/system";
import store from "../../../store/store";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import PeopleIcon from "@mui/icons-material/People";
import classNames from "classnames";

const styles = (theme) => ({
  appbar: {
    background: "transparent",
    padding: theme.spacing(2),
    boxShadow: "none",
    position: "absolute",
    margin: theme.spacing(1, 0),
    "& a": {
      textDecoration: "none",
      color: theme.palette.common.contrast,
    },
  },

  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
    boxShadow:
      theme.palette.mode === "light"
        ? "0px 1px 0px 0px #ccc"
        : "0px 1px 0px 0px #1d1d1d",
    // borderBottom: "1px solid #E2E8F0",
    background: "transparent",
    borderRadius: "8px",
  },

  navItems: {
    display: "flex",
    gap: theme.spacing(2),
    [theme.breakpoints.down("lg")]: {
      gap: 0,
    },
  },

  navItem: {
    padding: "10px 18px",

    borderRadius: "24px",
    "&.active": {
      background: theme.palette.common.white,
    },
  },

  ModeToggle: {
    display: "flex",
    justifyContent: "space-between",
    margin: "auto",
    cursor: "pointer",
    alignItems: "center",
    maxWidth: "300px",
    width: "100%",
    background: theme.palette.common.white,
    borderRadius: "48px",
    position: "relative",
    "& .item": {
      padding: theme.spacing(1.5),
      flex: 1,
      textAlign: "center",
      textTransform: "uppercase",
      color: "#64748B",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "75px",
      [theme.breakpoints.down("lg")]: {
        width: "50px",
      },
    },
  },

  slider: {
    width: "75px",
    height: "40px",
    background: theme.palette.primary.main,
    opacity: 0.1,
    position: "absolute",
    left: "3px",
    borderRadius: "48px",
    transition: "100ms",

    [theme.breakpoints.down("lg")]: {
      width: "50px",
    },
  },

  moved: {
    transform: "translateX(calc(100% - 5px))",
  },

  activeText: {
    color: theme.palette.primary.main,
    "& path": {
      stroke: theme.palette.primary.main,
    },
  },

  rightBtns: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },

  loginBtn: {
    // fontSize: "18px",
    padding: theme.spacing(1, 4),
    borderRadius: "32px",
  },
});

function NavBar(props) {
  const isAuthenticated = store.getState().login.isAuthenticated;
  const {
    classes,
    handleMobileDrawerOpen,
    handleMobileDrawerClose,
    mobileDrawerOpen,
    selectedTab,
    userLoggedIn,
    toggleDarkMode,
    themeMode,
    theme
  } = props;
  const handleLogout = () => {
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("email");
    window.location.reload();
  };
  const hist = useHistory();
  // const handleRegister = (selectedCompany) => {
  //   hist.push({
  //     pathname: "/auth/register",
  //     state: { selectedCompany: selectedCompany },
  //   });
  // };

  const menuItems = [
    {
      link: "/",
      name: "Home",
      icon: <HomeIcon className="grey" />,
    },
    {
      link: "/blog",
      name: "Blog",
      icon: <BlogIcon className="grey" />,
    },
    {
      link: "/video",
      name: "Videos",
      icon: <VideoIcon className="grey" />,
    },
    {
      link: "/faq",
      name: "FAQs",
      icon: <FAQIcon className="grey" />,
    },
    {
      link: "/pricing",
      name: "Pricing",
      icon: <PriceIcon className="grey" />,
    },
    {
      link: "/community",
      name: "Community",
      icon: <PeopleIcon className="grey" />,
    },
  ];

  // {
  //   name: `${isAuthenticated ? "Log out" : "Join Now"}`,
  //   onClick: isAuthenticated ? handleLogout : () => hist.push("/auth/login"),
  //   icon: <LockOpenIcon className="grey" />,
  // },

  const goToDashboard = (selectedCompany) => {
    console.log(userLoggedIn);
    if (userLoggedIn.logged && userLoggedIn.hasResume) {
      hist.push({
        pathname: "/c/profile",
        state: { selectedCompany: true },
      });
      return true;
    } else if (userLoggedIn.logged && !userLoggedIn.hasResume) {
      hist.push({
        pathname: "/c/profile",
        state: { selectedCompany: selectedCompany },
      });
      return true;
    } else if (!userLoggedIn.logged) {
      return false;
    }
  };

  console.log("sselected", selectedTab);

  return (
    <div className={classes.root}>
      <AppBar className={classes.appbar}>
        <Toolbar className={classes.toolbar}>
          <div>
            <img
              src={
                theme.palette.mode === "light"
                  ? "/images/Auralyze_ai_black_logo.png"
                  : "/images/auralyze_logo_white.png"
              }
              alt=""
            />
          </div>

          <Hidden mdUp>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {selectedTab === "Community" && (
                <Typography color={"black"}>{userLoggedIn.name}</Typography>
              )}
              <IconButton
                className={classes.menuButton}
                onClick={handleMobileDrawerOpen}
                aria-label="Open Navigation"
                size="large"
              >
                <MenuIcon color="primary" />
              </IconButton>
            </Box>
          </Hidden>

          <Hidden mdDown>
            <div className={classes.navItems}>
              {menuItems.map((item, index) => (
                <a
                  href={item.link}
                  key={index}
                  className={classNames(
                    classes.navItem,
                    selectedTab === item.name && "active"
                  )}
                  style={{ 
                    textDecoration: 'none',
                    display: 'inline-block',
                    padding: '12px 20px',
                    cursor: 'pointer',
                    minHeight: '44px',
                    touchAction: 'manipulation'
                  }}
                >
                  <Typography>{item.name}</Typography>
                </a>
              ))}
            </div>

            <div className={classes.rightBtns}>
              <div
                onClick={() => toggleDarkMode()}
                className={classes.ModeToggle}
              >
                <div className="item">
                  <svg
                    className={!themeMode ? classes.activeText : ""}
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                  >
                    <path
                      d="M9.5 14.375C12.1924 14.375 14.375 12.1924 14.375 9.5C14.375 6.80761 12.1924 4.625 9.5 4.625C6.80761 4.625 4.625 6.80761 4.625 9.5C4.625 12.1924 6.80761 14.375 9.5 14.375Z"
                      stroke="#94A3B8"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.855 14.855L14.7575 14.7575M14.7575 4.2425L14.855 4.145L14.7575 4.2425ZM4.145 14.855L4.2425 14.7575L4.145 14.855ZM9.5 2.06V2V2.06ZM9.5 17V16.94V17ZM2.06 9.5H2H2.06ZM17 9.5H16.94H17ZM4.2425 4.2425L4.145 4.145L4.2425 4.2425Z"
                      stroke="#94A3B8"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>

                <div className="item">
                  <svg
                    className={themeMode ? classes.activeText : ""}
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <path
                      d="M1.52232 9.81497C1.79232 13.6775 5.06982 16.82 8.99232 16.9925C11.7598 17.1125 14.2348 15.8225 15.7198 13.79C16.3348 12.9575 16.0048 12.4025 14.9773 12.59C14.4748 12.68 13.9573 12.7175 13.4173 12.695C9.74982 12.545 6.74982 9.47747 6.73482 5.85497C6.72732 4.87997 6.92982 3.95747 7.29732 3.11747C7.70232 2.18747 7.21482 1.74497 6.27732 2.14247C3.30732 3.39497 1.27482 6.38747 1.52232 9.81497Z"
                      stroke="#94A3B8"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>

                <div
                  className={classNames(
                    classes.slider,
                    themeMode && classes.moved
                  )}
                ></div>
              </div>

              <Button
                fullWidth
                variant="contained"
                className={classes.loginBtn}
                style={{
                  padding: "10px 24px",
                  cursor: "pointer",
                  position: "relative",
                  zIndex: 9999,
                  minWidth: "120px",
                  minHeight: "44px",
                  touchAction: "manipulation"
                }}
                onClick={(e) => {
                  e.preventDefault();
                  console.log("NavBar login button clicked");
                  if (isAuthenticated) {
                    handleLogout();
                  } else {
                    // Direct navigation with window.location for cross-browser compatibility
                    window.location.href = "/auth/login";
                  }
                }}
              >
                {isAuthenticated ? "Log Out" : "Join Now"}
              </Button>
            </div>
          </Hidden>
        </Toolbar>
      </AppBar>

      <NavigationDrawer
        menuItems={menuItems}
        anchor="right"
        open={mobileDrawerOpen}
        selectedItem={selectedTab}
        onClose={handleMobileDrawerClose}
        themeMode={themeMode}
        toggleDarkMode={toggleDarkMode}
        isAuthenticated={isAuthenticated}
        handleLogout={handleLogout}
      />
    </div>
  );
}

NavBar.propTypes = {
  classes: PropTypes.object.isRequired,
  handleMobileDrawerOpen: PropTypes.func,
  handleMobileDrawerClose: PropTypes.func,
  mobileDrawerOpen: PropTypes.bool,
  selectedTab: PropTypes.string,
  theme: PropTypes.object,
  toggleDarkMode: PropTypes.func,
  themeMode: PropTypes.bool,
  userLoggedIn: PropTypes.object
};

export default withStyles(styles, { withTheme: true })(memo(NavBar));
